<template>
    <form @submit.prevent="base_submit('model', 'submit', 'processing')">
        <div class="modals-modal-header">
            {{t('title')}}
        </div>
        <div class="modals-modal-body pt-4">
            <div class="row">
                <div class="col-12 text-center p-3">
                    {{t('header', {email: email})}}
                </div>
                <div class="col-12">
                    <form-select v-model="model.country"
                                 :validator="v$.model.country"
                                 :select-class="'form-control form-control-sm'"
                                 :label="t('model.country.label')"
                                 :options="countries"
                                 :option-value="'value'"
                                 :option-name="'name'"
                                 :disabled="processing"/>
                </div>
            </div>
        </div>

        <div class="modals-modal-footer">
            <button type="submit" class="btn btn-primary" :disabled="processing">
                <span v-if="true === processing">
                    <spinner/>
                    {{t('cta.submit.processing')}}
                </span>
                <span v-else>
                    {{t('cta.submit.text')}}
                </span>
            </button>

            <button type="button" class="btn btn-primary" @click="$emit('close')">{{t('cta.cancel.text')}}</button>
        </div>
    </form>
</template>

<script>

    import useVuelidate from "@vuelidate/core";
    import {email, required} from "@vuelidate/validators";

    import mixin_auth from "@/mixins/auth";
    import {PERMISSIONS} from "@/constants";

    import FormTextbox from "@/components/form/FormTextbox.vue";
    import FormSelect from "@/components/form/FormSelect.vue";
    import Spinner from "@/components/Spinner.vue";

    export default {
        name: "ModalImpersonationUserCountry",
        mixins: [mixin_auth],
        props: {
            email: {
                type: String,
                required: true
            }
        },
        components: {
            Spinner,
            FormSelect
        },
        setup() {
            return {
                v$: useVuelidate()
            }
        },
        data() {

            return {
                t_path: "modal.impersonation.user.country",
                processing: false,
                model: {
                    country: null
                }
            }
        },
        computed: {
            countries() {

                return this.$store.getters["db/countries/items"].map(country => ({
                    name: country.name,
                    value: country.alpha3
                }));
            },
        },
        validations() {

            return {
                model: {
                    country: {
                        required
                    },
                }
            }
        },
        methods: {
            submit() {

                this.$emit("save", this.model.country);
            }
        }
    }
</script>